import axios from 'axios';
import { getCache, clearCache, switchHeaderType } from '@/helpers';
import { grantNewAccessToken } from '@services/auth/authDataService';
import router from '@/internal/routes/routerIndex';
// Endpoints
export const version = 'v1';
export const baseDomain = (document.querySelector('base') || {}).href;
export const apiDomain = `${baseDomain}api/${version}`;
export const authUrl = `${apiDomain}/auth`;
export const userUrl = `${apiDomain}/user`;
export const usersUrl = `${apiDomain}/users`;
export const updateUserUrl = `${apiDomain}/user/update`;
export const corporateCustomerRegistrationUrl = `${apiDomain}/corporate-customer-registration/send-email`;
export const companyUrl = `${apiDomain}/company`;
export const areaCountyUrl = `${apiDomain}/areas`;
export const estateUrl = `${apiDomain}/estate`;
export const estatePropsUrl = `${estateUrl}/properties`;
export const attachFileUrl = `${apiDomain}/attachment-file`;
export const borderUrl = `${apiDomain}/municipal-border`;
// Instance
export const apiClient = axios.create({ baseURL: apiDomain });
apiClient.interceptors.request.use(async (config) => {
    const cache = getCache();
    config.headers['Accept'] = 'application/json';
    config.headers['Content-Type'] = 'application/json';
    if (cache && 'access_token' in cache) {
        config.headers['Authorization'] = `Bearer ${cache.access_token}`;
    }
    return config;
}, error => {
    Promise.reject(error);
});
apiClient.interceptors.response.use(res => {
    // Return a successful response back to the calling service!
    return res;
}, async (error) => {
    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 401) {
        // The Session/Token was killed in another tab/session.
        clearCache();
        switchHeaderType(false);
        // Reload instead of router.push, this will clear Vuex and treat it like new session.
        location.reload();
        return new Promise((resolve, reject) => reject(error.response.data));
    }
    // Wrong credentials
    if (error.response.data.message === 'failed attempt' && error.response.data.data === 'Unauthorized') {
        return new Promise((resolve, reject) => reject(error.response.data));
    }
    // Logout user if refresh_token didn't work
    if (error.config.url === `${authUrl}/refresh`) {
        clearCache();
        switchHeaderType(false);
        router.push({ name: 'login' });
        return new Promise((resolve, reject) => {
            reject(error);
        });
    }
    // Try request again with new token
    return grantNewAccessToken().then(newAccessToken => {
        const config = error.config;
        // Set the new access_token
        config.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return new Promise((resolve, reject) => {
            axios.request(config)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }).catch((error) => Promise.reject(error));
});
